/**
 * Media
 *
 * vuex module handles all media related components
 */

import { galleryState, galleryMutations, galleryGetters, galleryActions } from './gallery';
import { viewState, viewMutations, viewGetters, viewActions } from './view';
import { setState, setMutations, setGetters, setActions } from './set';
import { baState, baMutations, baGetters, baActions } from './before-after';
import { shareState, shareMutations, shareGetters, shareActions } from './share';
import { modalState, modalMutations, modalGetters, modalActions } from './modals';
import { selectState, selectMutations, selectGetters, selectActions } from './select';
import { uploadState, uploadMutations, uploadGetters, uploadActions } from './upload';
import { processedState, processedMutations, processedGetters, processedActions } from './processed';
import { versionActions } from './version'; // only has actions for now...
import { downloadActions, downloadGetters } from './download';

export const media = {
    state: {
        ...galleryState,
        ...viewState,
        ...setState,
        ...baState,
        ...shareState,
        ...modalState,
        ...selectState,
        ...uploadState,
        ...processedState,
    },
    mutations: {
        ...galleryMutations,
        ...viewMutations,
        ...setMutations,
        ...baMutations,
        ...shareMutations,
        ...modalMutations,
        ...selectMutations,
        ...uploadMutations,
        ...processedMutations,
    },
    getters: {
        ...galleryGetters,
        ...viewGetters,
        ...setGetters,
        ...baGetters,
        ...shareGetters,
        ...modalGetters,
        ...selectGetters,
        ...uploadGetters,
        ...processedGetters,
        ...downloadGetters,
    },
    actions: {
        ...galleryActions,
        ...viewActions,
        ...setActions,
        ...baActions,
        ...shareActions,
        ...modalActions,
        ...selectActions,
        ...uploadActions,
        ...versionActions,
        ...downloadActions,
        ...processedActions,
    },
};
